// Spec §5 / DESIGN-DECISIONS §5: the passive channel. Boredom and entrancement
// deliberately have no icons — a bored viewer will not reach for a button, and an
// entranced one will not break the spell to tap. Both are measurable for free
// from the player's own clock and state, so we sample instead of asking.
const SAMPLE_INTERVAL_MS = 500;

// Drives a 500ms sampler. Returns its own stop function rather than exposing the
// interval id, so a caller cannot leave one running.
export function engagementSampler(input: {
  readCurrentTimeMs: () => number;
  readPlayerState: () => number;
  onSample: (sample: { video_time_ms: number; player_state: number }) => void;
}): () => void {
  const timer = window.setInterval(() => {
    input.onSample({
      video_time_ms: input.readCurrentTimeMs(),
      player_state: input.readPlayerState()
    });
  }, SAMPLE_INTERVAL_MS);

  return () => window.clearInterval(timer);
}
